/**
 * BDC 列表页表格高度：与 gameOverview 一致，通过 bdcTableArea 容器计算 el-table height
 */
export default {
  data() {
    return {
      bdcTableHeight: 400
    }
  },

  computed: {
    tableHeightDaily() {
      return this.isBdc ? this.bdcTableHeight : undefined
    }
  },

  watch: {
    listLoading(val) {
      if (this.isBdc && !val) {
        this.updateBdcTableHeight()
      }
    }
  },

  mounted() {
    if (this.isBdc) {
      this.initBdcTableLayout()
    }
  },

  beforeDestroy() {
    this.destroyBdcTableLayout()
  },

  methods: {
    initBdcTableLayout() {
      this.updateBdcTableHeight()
      if (typeof ResizeObserver !== 'undefined') {
        this._bdcTableObserver = new ResizeObserver(() => {
          clearTimeout(this._bdcTableResizeTimer)
          this._bdcTableResizeTimer = setTimeout(() => {
            this.updateBdcTableHeight()
          }, 100)
        })
        this.$nextTick(() => {
          if (this.$refs.bdcTableArea) {
            this._bdcTableObserver.observe(this.$refs.bdcTableArea)
          }
        })
      } else {
        this._bdcTableResizeHandler = () => this.updateBdcTableHeight()
        window.addEventListener('resize', this._bdcTableResizeHandler)
      }
    },

    destroyBdcTableLayout() {
      clearTimeout(this._bdcTableResizeTimer)
      if (this._bdcTableObserver) {
        this._bdcTableObserver.disconnect()
        this._bdcTableObserver = null
      }
      if (this._bdcTableResizeHandler) {
        window.removeEventListener('resize', this._bdcTableResizeHandler)
        this._bdcTableResizeHandler = null
      }
    },

    updateBdcTableHeight() {
      this.$nextTick(() => {
        const area = this.$refs.bdcTableArea
        if (area) {
          this.bdcTableHeight = Math.max(area.clientHeight, 240)
        }
      })
    }
  }
}
